import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBlocked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#A5A5AA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m10.667 3.219-4.699 1.77C4.885 5.394 4 6.675 4 7.823v6.997c0 1.11.734 2.57 1.629 3.239l4.049 3.022c1.328.998 3.512.998 4.84 0l4.049-3.022c.894-.669 1.629-2.128 1.629-3.24V7.824c0-1.158-.885-2.438-1.968-2.843L13.529 3.22c-.8-.292-2.08-.292-2.862 0Z"
    />
    <path
      stroke="#A5A5AA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M12.089 12.89a1.883 1.883 0 1 0 0-3.767 1.883 1.883 0 0 0 0 3.766Zm0 0v2.824"
    />
  </svg>
);
export default SvgBlocked;
